import React, { useState, useEffect } from "react";
import Elements from "./Elements";
import "./Schedule.css";
import schedule from "../json/schedule.json";
import { set } from "internal-slot";
import axios from "axios";


const Schedule = () => {
    const [getSchedule, setGetSchedule] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(false);

    // useEffect(() => {
    //     const getScheduleContents = async () => {
    //         try {
    //             const response = await axios.get("http://127.0.0.1:8000/api/schedules");
    //             setGetSchedule(response.data);
    //             console.log('response.data', response.data);
    //         } catch (error) {
    //             console.error('データの取得ができませんでした。', error);
    //         }

    //     }
    //     getScheduleContents();
    // }, [refreshFlag]);

    const insertStr = (str) => {
        return (
            str.slice(0, 4) +
            "年" +
            str.slice(5, 7) +
            "月" +
            str.slice(8, 10) +
            "日"
        );
    }


    return (
        <div className="schedule-wrapper">
            <div className="schedule-title">
                <span className="schedule-title-text">
                    Schedule
                </span>
            </div>
            <section className="schedule-section-wrapper">
                {/* {getSchedule.map((item, index) => { */}
                {schedule.map((item, index) => {

                    console.log("image_path:", item.image_path);



                    return (
                        <div key={index}>
                            <Elements
                                key={index}
                                id={item.id}
                                date={insertStr(item.date)}
                                image_path={item.image_path}
                                location={item.location}
                                address={item.address}
                                title={item.title}
                                artist={item.artist}
                                contents={item.contents}
                                open_time={item.open_time}
                                start_time={item.start_time}
                                door_price={item.door_price}
                                adv_price={item.adv_price}
                                drink_price={item.drink_price}
                                etc={item.etc}
                            />
                        </div>
                    );
                })}



            </section>
        </div>

    );
}
export default Schedule;